import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { AutoComplete } from "antd";
import convertToExcel from "../../../../components/ExportToExcel";

const FarmerComplianceReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const [seasonlist, setSeasonlist] = useState(null);
  const [seasonId, setSeasonId] = useState();

  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();

  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getprocurementData } = useHttp();

  const fillprocurementData = (e) => {
    if (e) e.preventDefault();

    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }

    if (farmerNumber) {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }

    var url = `/api/farmerScoreboardReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  // useEffect(() => {
  //   fillprocurementData();
  // }, [getprocurementData]);

  const handleExportExcel = () => {
    const filename = "FarmerComplianceReport.xlsx";

    const fieldsToExport = [
      "farmerNo",
      "farmerName",
      "cropName",
      "fieldCategory",
      "fieldId",
      "executiveName",
      "plotArea",
      "plotSizeUnit",
    ];

    // Add activity fields
    Object?.entries(activityStructure)?.forEach(([heading, subs]) => {
      subs?.forEach((_, idx) => {
        fieldsToExport?.push(`${heading}_${idx}`);
      });
    });

    // Add final columns
    fieldsToExport?.push("totalScore", "percentage");

    // Build row data
    const exportData = data?.map((itm) => {
      const row = {
        farmerNo: itm.farmerNo,
        farmerName: itm.farmerName,
        cropName: itm.cropName,
        fieldCategory: itm.ranchName,
        fieldId: itm.plotCode,
        executiveName: itm.executiveName,
        plotArea: itm.plotArea,          // ✔ FIXED
        plotSizeUnit: itm.plotSizeUnit
      };

      Object?.entries(activityStructure)?.forEach(([heading, subs]) => {
        const act = itm.activities?.find((a) => a.mainHeading === heading);
        const ratings = act?.subHeadings || [];

        subs?.forEach((subLabel, idx) => {
          let ratingLabel = "-";

          if (heading === "Farm Management") {
            const match = ratings?.find((r) => r.activity === subLabel);
            ratingLabel = match?.ratingLabel ?? "-";
          } else {
            ratingLabel = ratings[idx]?.ratingLabel ?? "-";
          }

          row[`${heading}_${idx}`] = ratingLabel;
        });
      });

      row.totalScore = itm.totalScore;
      row.percentage = itm.percentage;

      return row;
    });

    // Generate readable headers
    const customHeaders = [
      "farmerNo",
      "farmerName",
      "cropName",
      "fieldCategory",
      "fieldId",
      "executiveName",
      "plotArea",
      "Plot Size Unit",
      ...Object?.entries(activityStructure)?.flatMap(([heading, subs]) =>
        subs?.map((sub) => `${heading} - ${sub}`)
      ),
      "Total Score",
      "Percentage (%)",
    ];

    convertToExcel(exportData, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const [expandedGroups, setExpandedGroups] = useState({});

  // Toggle function
  const toggleGroup = (group) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };

  // activityStructure creation (unchanged from your code)
  const activityStructure = {};
  data?.forEach((item) => {
    item.activities?.forEach((act) => {
      const key = act.mainHeading;
      if (!activityStructure[key]) activityStructure[key] = [];
      act.subHeadings.forEach((sub, idx) => {
        const label =
          act.mainHeading === "Farm Management"
            ? sub.activity
            : `${key} ${idx + 1}`;
        if (!activityStructure[key].includes(label)) {
          activityStructure[key].push(label);
        }
      });
    });
  });

  useEffect(() => {
    const initialState = {};
    Object.keys(activityStructure).forEach((heading) => {
      initialState[heading] = true; // expanded by default
    });
    setExpandedGroups(initialState);
  }, [data]);

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    if (!employeeId || isNaN(employeeId)) return;
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  useEffect(() => {
    fillprocurementData();
  }, [seasonId, employeeId, ranchId]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Farmer Compliance </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          {" "}
          <form onSubmit={fillprocurementData}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Season</label>
                    <select
                      id="season"
                      className="form-control"
                      value={seasonId}
                      onChange={(e) => setSeasonId(e.target.value || 0)}
                    // required
                    >
                      <option value="">Select</option>
                      {seasonlist &&
                        seasonlist.map((x) => (
                          <option key={x.seasonId} value={x.seasonId}>
                            {x.seasonName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>Ranch</label>
                    <select
                      id="ranch"
                      className="form-control"
                      value={ranchId}
                      onChange={(e) => setRanchId(e.target.value || 0)}
                    >
                      <option value="">Select</option>
                      {ranchData &&
                        ranchData.map((x) => (
                          <option key={x.ranchId} value={x.ranchId}>
                            {x.ranchName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor={"executive_officer"}>
                      {"Field Officer"}
                    </label>
                    <select
                      id="emp_id"
                      className="form-control"
                      ref={(el) => (frmRef.current["emp_id"] = el)}
                      value={employeeId}
                      onChange={(e) => {
                        setEmployeeId(e.target.value || 0);
                        setData([]);
                      }}
                    >
                      <option value={0}>Select</option>
                      {employeeData &&
                        employeeData.map((x) => (
                          <option
                            key={x.userId}
                            user-id={x.userId}
                            value={x.userId}
                          >
                            {x.employeeName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="farmer_number">Farmer Number</label>
                  <AutoComplete
                    className="form-control"
                    style={{ height: "30px" }}
                    value={farmerNumber}
                    options={filteredOptions}
                    placeholder="Farmer Number"
                    onChange={handleSearch}
                  />
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <button className="form-control btn btn-sm btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </div>{" "}
            </div>{" "}
          </form>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card" style={{ overflow: "hidden" }}>
                  {currentItems.length > 0 ? (
                    <>
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered text-center mb-0">
                            <thead>
                              {/* Row 1: Farmer details + expandable groups */}
                              <tr className="table-header tableheaderrowview">
                                <th colSpan={8}>Farmer Details</th>
                                {Object.entries(activityStructure).map(
                                  ([heading, subs]) => (
                                    <th
                                      key={heading}
                                      colSpan={
                                        expandedGroups[heading]
                                          ? subs.length || 1
                                          : 1
                                      }
                                      onClick={() => toggleGroup(heading)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {heading}{" "}
                                      {expandedGroups[heading] ? "–" : "+"}
                                    </th>
                                  )
                                )}
                                <th rowSpan={2}>Total Score</th>
                                <th rowSpan={2}>Percentage</th>
                              </tr>

                              {/* Row 2: Sub-headers */}
                              <tr className="table-subheader">
                                <th>Farmer Id</th>
                                <th>Farmer Name</th>
                                <th>Crop</th>
                                <th>Field Category</th>
                                <th>Field ID</th>
                                <th>Extension Officer</th>
                                <th>Season Name</th>
                                <th>Field Size</th>
                                {/* <th>Plot Name</th> */}
                                {/* <th>Plot Size Unit</th>
                              
                         
                              <th>Ranch Name</th> */}

                                {Object.entries(activityStructure).map(
                                  ([heading, subs]) =>
                                    expandedGroups[heading] ? (
                                      subs.length > 0 ? (
                                        subs.map((subLabel, idx) => (
                                          <th key={`${heading}_${idx}`}>
                                            {subLabel}
                                          </th>
                                        ))
                                      ) : (
                                        <th>-</th>
                                      )
                                    ) : (
                                      <th>-</th>
                                    )
                                )}
                              </tr>
                            </thead>

                            <tbody>
                              {currentItems.map((itm, i) => (
                                <tr key={i}>
                                  <td>{itm.farmerNo}</td>
                                  <td>{itm.farmerName}</td>
                                  <td>{itm.cropName}</td>
                                  <td>{itm.ranchName}</td>
                                  <td>{itm.plotCode}</td>
                                  <td>{itm.executiveName}</td>
                                  <td>{itm.seasonName}</td>
                                  <td>{formatNumber(itm.plotArea)}</td>{" "}
                                  {/* numeric formatted */}
                                  {Object.entries(activityStructure).map(
                                    ([heading, subs]) => {
                                      const act = itm.activities?.find(
                                        (a) => a.mainHeading === heading
                                      );
                                      const ratings = act?.subHeadings || [];

                                      if (!expandedGroups[heading]) {
                                        return (
                                          <td key={`${i}_${heading}_collapsed`}>
                                            -
                                          </td>
                                        );
                                      }

                                      return subs.map((subLabel, idx) => {
                                        let ratingLabel = "-";
                                        if (heading === "Farm Management") {
                                          const match = ratings.find(
                                            (r) => r.activity === subLabel
                                          );
                                          ratingLabel = match?.ratingLabel ?? "-";
                                        } else {
                                          ratingLabel =
                                            ratings[idx]?.ratingLabel ?? "-";
                                        }

                                        // check if ratingLabel is numeric
                                        const isNumeric =
                                          !isNaN(parseFloat(ratingLabel)) &&
                                          isFinite(ratingLabel);

                                        return (
                                          <td key={`${i}_${heading}_${idx}`}>
                                            {isNumeric
                                              ? formatNumber(ratingLabel)
                                              : ratingLabel}
                                          </td>
                                        );
                                      });
                                    }
                                  )}
                                  <td>{formatNumber(itm.totalScore)}</td>{" "}

                                  <td>{formatNumber(itm.percentage)}%</td>{" "}
                                  {/* numeric formatted */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="card-footer clearfix">
                        <Pagination
                          totalItems={data.length}
                          itemsPerPage={itemsPerPage}
                          onPageChange={paginate}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                        />
                      </div>{" "}
                    </>
                  ) : (
                    <p className="text-center">No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerComplianceReport;
